export const accountTypeValues = [
    "SAVINGS",
    "TRANSACTION",
    "FIXED_INCOME_FUND",
    "FX",
    "NOTICE_ACCOUNT",
    "TERM_DEPOSIT",
];
export const accountsGroupKindInputValues = [
    "BUSINESS_ENTITY",
    "PROVIDER",
    "CURRENCY",
    "ACCOUNT_TYPE",
    "ASSET_CLASS",
];
export const achAccountTypeValues = ["CHECKING", "SAVINGS"];
export const activityStatementFormatValues = ["NETSUITE", "XERO"];
export const airwallexConnectionStatusValues = [
    "INITIALISING",
    "ACTIVE",
    "DELETED",
    "RECONNECT_REQUIRED",
];
export const alertRuleHistoryResultValues = [
    "NEW_REMINDER_CREATED",
    "EXISTING_REMINDER_EXISTS",
    "NO_ACTION_REQUIRED",
];
export const alertRuleUserTaskActionTypeValues = ["TOP_UP", "SWEEP"];
export const approvalRequestResultValues = [
    "APPROVED",
    "PENDING",
    "REJECTED",
];
export const approvalReviewDecisionValues = ["APPROVED", "REJECTED"];
export const assetClassValues = [
    "EXTERNAL_BANK_ACCOUNT",
    "FIXED_INCOME_FUND",
    "FX",
    "NOTICE_ACCOUNT",
    "SAVINGS",
    "TERM_DEPOSIT",
];
export const assetLedgerAccountKindValues = [
    "BALANCE",
    "INCOMING",
    "OUTGOING",
    "PROVIDER_FEES",
    "PROVIDER_INCOME",
    "UNCATEGORIZED",
];
export const assetRebalanceFXExecutionModeValues = [
    "DEFERRED",
    "IMMEDIATE",
];
export const assetRebalanceKindValues = [
    "REBALANCE",
    "WITHDRAWAL",
    "TRANSFER_INTERNAL",
    "TRANSFER_WITHDRAWAL",
];
export const assetRuleEvaluationCadenceValues = [
    "DAILY",
    "WEEKLY",
    "MONTHLY",
];
export const assetRuleEvaluationStatusValues = ["HEALTHY", "BREACH"];
export const assetRuleStatusValues = ["ACTIVE", "INACTIVE"];
export const assetRuleTypeValues = [
    "TOP_UP",
    "RECURRING_WITHDRAWAL",
    "ALERT",
];
export const assetStatusValues = [
    "ACTIVE",
    "CLOSED",
    "HOLDING",
    "MATURED",
    "PENDING",
    "SCHEDULED",
    "DISABLED",
    "DELETED",
];
export const balanceForecastTimeSeriesIntervalValues = [
    "WEEK",
    "FORTNIGHT",
];
export const balanceTimeseriesRangeValues = [
    "ONE_MONTH",
    "SIX_MONTHS",
    "ONE_YEAR",
];
export const beneficiaryAccountKindValues = [
    "VERIFIED_BENEFICIARY",
    "PAYEE",
];
export const beneficiaryAccountStatusValues = [
    "ACTIVE",
    "CLOSED",
    "DELETED",
    "DISABLED",
    "INITIAL",
    "PENDING",
];
export const blackrockOrderKindValues = ["APPLICATION", "REDEMPTION"];
export const brexConnectionStatusValues = [
    "INITIALISING",
    "ACTIVE",
    "INACTIVE",
    "RECONNECT_REQUIRED",
];
export const bypassApprovalRequestReasonValues = [
    "APPROVAL_NOT_APPLICABLE",
    "DO_NOT_BYPASS_APPROVAL_POLICY",
    "TRANSFER_CREATED_RETROACTIVELY",
    "OPERATOR_BYPASSED_POLICY",
];
export const calastoneTransactionStatusValues = [
    "TO_PROCESS",
    "PRICED",
    "VOID",
    "PROCESSED",
];
export const cashflowRangeValues = ["THREE_MONTHS"];
export const createAssetStatusValues = ["ACTIVE", "CLOSED", "PENDING"];
export const createTermDepositApprovalTypeValues = [
    "REQUIRED",
    "BYPASS",
    "BYPASS_WITHOUT_NOTIFYING",
];
export const currencyValues = [
    "AUD",
    "CAD",
    "CNY",
    "EUR",
    "GBP",
    "HKD",
    "JPY",
    "NZD",
    "SGD",
    "USD",
    "MYR",
    "BRL",
];
export const currencyDownsideRiskRatingValues = [
    "NEGLIGIBLE",
    "LOW",
    "MODERATE",
    "HIGH",
];
export const currencycloudAccountStatusValues = [
    "ENABLED",
    "DISABLED",
    "ENABLED_NO_TRADING",
];
export const currencycloudBeneficiaryPaymentTypeValues = [
    "REGULAR",
    "PRIORITY",
];
export const currencycloudPaymentStatusValues = [
    "AWAITING_AUTHORISATION",
    "AUTHORISED",
    "COMPLETED",
    "DELETED",
    "FAILED",
    "NEW",
    "READY_TO_SEND",
    "RELEASED",
    "SUBMITTED",
    "SUSPENDED",
];
export const currencycloudSettlementTypeValues = ["BULK", "NET"];
export const custodyLedgerAccountKindValues = [
    "INCOMING",
    "OUTGOING",
    "UNASSIGNED",
];
export const depositsPageOrderValues = ["DATE_ASC", "DATE_DESC"];
export const eburyClientCreditConditionsKindValues = [
    "SPOT",
    "FORWARD",
];
export const eburyFxTradeReasonValues = [
    "CHARITABLE_AID",
    "PAYMENT_FOR_GOODS",
    "CAPITAL_INVESTMENT",
    "PAYMENT_FOR_SERVICES",
    "REPATRIATION_OF_GOODS",
    "REPATRIATION_OF_SERVICES",
    "PROPERTY_PURCHASE",
    "MORTAGE_REPAYMENT",
    "PROPERTY_RENTAL_OR_MAINTENANCE",
    "SALARY_PAYROLL",
    "TRAVEL_COSTS",
    "LIVING_COSTS",
    "REPAYMENT_OF_LOAN",
    "BALANCE_HEDGING",
    "REPATRIATION_FROM_INVESTMENT",
    "PORTFOLIO_NETTING",
    "NOT_RELATED_TO_GOODS_OR_SERVICES",
    "OTHER",
];
export const environmentValues = [
    "DEVELOPMENT",
    "STAGING",
    "PRODUCTION",
];
export const estimatedReturnsCalculatorPayoutFrequencyValues = [
    "WEEKLY",
    "FORTNIGHTLY",
    "MONTHLY",
    "QUARTERLY",
    "YEARLY",
];
export const externalBankAccountDataSourceValues = [
    "SISS",
    "QUILTT",
    "AKAHU",
    "SALT_EDGE",
    "SKRIPT",
    "STRIPE",
    "MERCURY",
    "AIRWALLEX",
    "BREX",
    "RAMP",
];
export const fXHedgeKindValues = ["FIXED_FORWARD", "WINDOW_FORWARD"];
export const fXOnboardingRequestStatusValues = [
    "PENDING",
    "ACCOUNT_OPENED",
    "CANCELLED",
];
export const fXRateRangeValues = [
    "ONE_DAY",
    "ONE_WEEK",
    "ONE_MONTH",
    "THREE_MONTHS",
    "SIX_MONTHS",
    "ONE_YEAR",
];
export const fXRateSamplePeriodValues = [
    "MONTH",
    "WEEK",
    "DAY",
    "HOUR",
    "THIRTY_MINUTE",
    "FIFTEEN_MINUTE",
    "FIVE_MINUTE",
    "MINUTE",
];
export const fXTradeDatePreferenceValues = [
    "DEFAULT",
    "EARLIEST",
    "NEXT_DAY",
    "OPTIMIZE_LIQUIDITY",
];
export const fXTradeFundDestinationValues = [
    "TRANSFER_OUT",
    "PAYOUT",
    "WALLET",
];
export const fXTradeFundSourceValues = ["TRANSFER_IN", "WALLET"];
export const fXTradeOperationValues = ["BUY", "SELL"];
export const fXTradeStatusValues = [
    "CREATED",
    "PLACED",
    "OPEN",
    "CANCELLED",
    "COMPLETED",
    "VOIDED",
];
export const fXTradeTimeLogUpdateKindValues = [
    "CREATED",
    "MARGIN_PAID",
    "MARGIN_RETURNED",
    "DRAWDOWN_REQUESTED",
    "DRAWDOWN_EXECUTED",
];
export const fXTradeTransferGroupKindValues = [
    "FUNDING",
    "WITHDRAWAL",
    "MARGIN",
    "REBALANCE",
    "CONVERSION",
    "DRAWDOWN",
];
export const fXTradeTypeValues = [
    "SPOT",
    "FIXED_FORWARD",
    "WINDOW_FORWARD",
];
export const fileImportKindValues = [
    "MACQUARIE_TRANSACTION_FILE",
    "WESTPAC_TRANSACTION_FILE",
];
export const fundDistributionKindValues = [
    "ACCUMULATING",
    "DISTRIBUTING",
];
export const fundInvestmentStyleValues = ["ACTIVE", "PASSIVE"];
export const fundKindValues = ["FIXED_INCOME", "MONEY_MARKET"];
export const importFilePageOrderValues = ["DATE_ASC", "DATE_DESC"];
export const ledgerEntryDirectionValues = ["CREDIT", "DEBIT"];
export const ledgerTransactionAnnotationValues = [
    "DIRECT_WITHDRAWAL",
    "PROVIDER_FEE",
    "TAX",
    "YIELD",
    "YIELD_REINVESTMENT",
    "YIELD_REMITTANCE",
    "BALANCE_SYNC",
];
export const ledgerTransactionTypeValues = [
    "BALANCE_SYNC",
    "DEPOSIT",
    "DIRECT_WITHDRAWAL",
    "MARGIN",
    "PAYOUT",
    "PROVIDER_FEE",
    "STATEMENT_FEE",
    "TAX",
    "TRANSFER_BRIDGE",
    "TRANSFER_IN",
    "TRANSFER_OUT",
    "YIELD",
    "YIELD_REINVESTMENT",
    "YIELD_REMITTANCE",
];
export const liquidityClassValues = [
    "CASH",
    "LINKED",
    "RESERVE",
    "STRATEGIC",
];
export const macquarieTransactionImportFilePageOrderValues = [
    "DATE_ASC",
    "DATE_DESC",
];
export const mercuryAccountTypeValues = [
    "MERCURY",
    "EXTERNAL",
    "RECIPIENT",
    "TREASURY",
];
export const orderDirectionValues = ["ASC", "DESC"];
export const organisationApprovalPolicyKindValues = [
    "PAYOUTS",
    "TRANSFERS",
    "THIRD_PARTY_PAYMENTS",
];
export const organisationFeePaymentMethodValues = [
    "INVOICE",
    "DIRECT_DEBIT",
];
export const paymentInstructionFileKindValues = [
    "MACQUARIE_CMA_EGRESS",
    "MACQUARIE_CMA_ACCELERATOR_EGRESS",
    "PERPETUAL_BUNDLE",
    "PERPETUAL_WESTPAC_EGRESS",
];
export const paymentInstructionFileStatusValues = [
    "PENDING",
    "CANCELLED",
    "SUBMITTED_TO_PROVIDER",
];
export const payoutActionKindValues = [
    "CANCELLED",
    "EXECUTION_CANCELLED",
    "EXECUTION_FAILED",
    "EXECUTION_STARTED",
    "EXECUTION_SUCCESSFUL",
    "VALIDATION_FAILED",
    "VALIDATION_SUCCESSFUL",
    "VOIDED",
];
export const payoutAuthorisationFormKindValues = [
    "SSGA_WITHDRAWAL_REQUEST",
];
export const payoutStatusValues = [
    "CANCELLED",
    "COMPLETED",
    "FAILED",
    "IN_PROGRESS",
    "REJECTED",
    "REQUESTED",
    "SCHEDULED",
    "USER_REVIEW_REQUIRED",
    "VOIDED",
];
export const payoutTimeLogUpdateKindValues = [
    "created",
    "status_transition",
    "approval_review",
];
export const payoutsPageOrderValues = ["DATE_ASC", "DATE_DESC"];
export const sissAccountStatusValues = [
    "ACTIVE",
    "APPROVAL_RECEIVED_BY_SISS",
    "APPROVAL_SENT_TO_CLIENT",
    "CANCELLED_BY_SISS",
    "CREATED",
    "DISCONNECTED",
    "CLOSED",
    "PROBLEM",
];
export const skriptArrangementStatusValues = [
    "ACTIVE",
    "EXPIRED",
    "REVOKED",
    "DISCLOSURE_PENDING",
];
export const statementActionKindValues = [
    "PUBLISH",
    "REGENERATE",
    "VOID",
];
export const statementKindValues = ["ACTIVITY", "BALANCE", "MONTHLY"];
export const statementStatusValues = [
    "PUBLISHED",
    "VOIDED",
    "PROCESSING",
    "STAFF_REVIEW_REQUIRED",
];
export const stripeConnectionStatusValues = [
    "INITIALISING",
    "ACTIVE",
    "INACTIVE",
    "RECONNECT_REQUIRED",
];
export const stripePayoutQueueItemStatusValues = [
    "PENDING",
    "PAID",
    "VOIDED",
];
export const stripePayoutStatusValues = [
    "PAID",
    "PENDING",
    "IN_TRANSIT",
    "CANCELED",
    "FAILED",
];
export const termDepositRolloverStrategyValues = [
    "SIMPLE_TERM",
    "TIME_LADDERED",
];
export const topUpRuleHistoryResultValues = [
    "NO_ACTION_REQUIRED",
    "EXISTING_TRANSFERS_IN_PROGRESS",
    "INSUFFICIENT_FUNDS",
    "ASSET_REBALANCE_CREATED",
];
export const transactionExecutionMethodValues = [
    "MANUAL",
    "EBURY_PAYMENT",
    "EBURY_FX_TRADE",
    "CURRENCYCLOUD_PAYMENT",
    "CURRENCYCLOUD_FX_TRADE",
];
export const transactionFileTransactionStatusValues = [
    "NEW",
    "UNKNOWN",
    "EXISTING",
];
export const transactionPageOrderValues = [
    "AMOUNT_ASC",
    "AMOUNT_DESC",
    "EFFECTIVE_AT_ASC",
    "EFFECTIVE_AT_DESC",
];
export const transactionStatusValues = [
    "DRAFT",
    "PENDING",
    "POSTED",
    "VOIDED",
];
export const transactionTypeValues = [
    "BALANCE_SYNC",
    "DEPOSIT",
    "DIRECT_WITHDRAWAL",
    "FUND_TRADE",
    "MARGIN",
    "PAYOUT",
    "PROVIDER_FEE",
    "STATEMENT_FEE",
    "TAX",
    "TRANSFER_IN",
    "TRANSFER_OUT",
    "UNCATEGORISED",
    "YIELD",
    "YIELD_REINVESTMENT",
    "YIELD_REMITTANCE",
];
export const transferActionKindValues = [
    "CANCELLED",
    "VOIDED",
    "EXECUTION_CANCELLED",
    "EXECUTION_FAILED",
    "EXECUTION_STARTED",
    "EXECUTION_SUCCESSFUL",
    "RECONCILIATION_FAILED",
    "RECONCILIATION_SUCCESSFUL",
    "VALIDATION_FAILED",
    "VALIDATION_SUCCESSFUL",
];
export const transferAuthorisationFormKindValues = [
    "SSGA_APPLICATION_REQUEST",
    "SSGA_WITHDRAWAL_REQUEST",
];
export const transferGroupActionKindValues = ["CANCELLED"];
export const transferGroupKindValues = [
    "REBALANCE",
    "REBALANCE_WITHDRAWAL",
    "REBALANCE_PAYMENT",
    "TRANSFER_INTERNAL",
    "TRANSFER_WITHDRAWAL",
];
export const transferGroupPageOrderValues = [
    "CREATED_AT_ASC",
    "CREATED_AT_DESC",
];
export const transferGroupStatusValues = [
    "CANCELLED",
    "COMPLETED",
    "FAILED",
    "IN_PROGRESS",
    "PENDING",
    "REQUESTED",
    "SCHEDULED",
    "USER_REVIEW_REQUIRED",
    "REJECTED",
    "VOIDED",
];
export const transferPageOrderValues = ["DATE_ASC", "DATE_DESC"];
export const transferSideValues = ["SOURCE", "DESTINATION"];
export const transferStatusValues = [
    "CANCELLED",
    "COMPLETED",
    "FAILED",
    "IN_PROGRESS",
    "PENDING",
    "REQUESTED",
    "SCHEDULED",
    "USER_REVIEW_REQUIRED",
    "REJECTED",
    "VOIDED",
];
export const updateAssetStatusValues = ["ACTIVE", "CLOSED", "PENDING"];
export const usAbaValidNetworksValues = ["ACH", "FEDWIRE"];
export const userMfaRequirementValues = ["REQUIRED", "NOT_REQUIRED"];
export const userTaskKindValues = [
    "APPROVAL_REQUEST",
    "GROUPED_APPROVAL_REQUEST",
    "ALERT_RULE",
    "MANAGE_ALLOCATIONS",
    "FX_FUNDING",
    "EXTERNAL_ACCOUNT_RELINKING",
    "GROUPED_EXTERNAL_ACCOUNT_RELINKING",
];
export const userTaskStatusValues = ["OPEN", "DISMISSED", "COMPLETED"];
export const westpacPaymentInstructionStatusValues = [
    "CREATED",
    "SUBMITTED",
    "RECONCILED",
    "VOID",
];
export const withdrawalRuleHistoryResultValues = [
    "NO_ACTION_REQUIRED",
    "EXISTING_TRANSFERS_IN_PROGRESS",
    "INSUFFICIENT_FUNDS",
    "ASSET_REBALANCE_CREATED",
];
export const xeroAccountLinkChecklistStatusValues = [
    "TODO",
    "COMPLETED",
    "DISMISSED",
];
export const xeroConnectionStatusValues = [
    "INITIALISING",
    "ACTIVE",
    "INACTIVE",
    "RECONNECT_REQUIRED",
];
